module.exports = __webpack_public_path__ + "static/media/linkedin-brands.9623de0e.svg";